import type { ResultsReduxState } from "@app/types/results-redux-types";

export const getTripById = (state: ResultsReduxState, trip_id: string) => {
  return state.trips[trip_id];
};
